import { render, staticRenderFns } from "./TextValueLabel.vue?vue&type=template&id=650ebf28&"
import script from "./TextValueLabel.vue?vue&type=script&lang=js&"
export * from "./TextValueLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports